import { DatePicker, Input, Radio, Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import * as React from "react";
import { FormInstance } from "antd/lib/form";
import { TableAPI } from "../../API/TableAPI";
import makeEntryModal from "./CreateEntryModals";
import Entry from "../../Model/Entry";
import moment from "moment";

const { RangePicker } = DatePicker;

function renderForm(form: FormInstance) {
  return (
    <Form
      className="modal-form"
      hideRequiredMark={true}
      form={form}
      initialValues={{
        isWavelengthApplicable: true,
        isSatelliteActive: true,
      }}
    >
      <Form.Item
        name="parameter"
        label="Parameter"
        rules={[
          { required: true, message: "Parameter is required" },
          { max: 120, message: "Value can't be longer than 120 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="expedition"
        label="Expedition"
        rules={[
          { required: true, message: "Expedition is required" },
          { max: 200, message: "Value can't be longer than 200 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="instrument"
        label="Instrument"
        rules={[
          { required: true, message: "Instrument is required" },
          { max: 120, message: "Value can't be longer than 120 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="unit"
        label="Unit"
        rules={[
          { required: true, message: "Unit is required" },
          { max: 100, message: "Value can't be longer than 100 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="waterDepth"
        label="Water Depth"
        rules={[
          { required: true, message: "Water Depth is required" },
          { max: 30, message: "Value can't be longer than 30 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="spatialFrom"
        label="Spatial From"
        rules={[
          { required: true, message: "Field is required" },
          { max: 100, message: "Value can't be longer than 100 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="spatialTo"
        label="Spatial To"
        rules={[
          { required: true, message: "Field is required" },
          { max: 100, message: "Value can't be longer than 100 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="temporalResolution"
        label="Temporal Resolution"
        rules={[
          { required: true, message: "TemporalResolution is required" },
          { max: 100, message: "Value can't be longer than 100 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="timespan"
        label="Time range"
        rules={[{ required: true, message: "This field is not optional" }]}
      >
        <RangePicker format="YYYY-MM-DD" />
      </Form.Item>
      <Form.Item
        name="dataFormat"
        label="Data Format"
        rules={[
          { required: true, message: "DataFormat is required" },
          { max: 100, message: "Value can't be longer than 100 characters" },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="openAccess" label="Open access?" required>
        <Radio.Group buttonStyle="solid">
          <Radio.Button value={true}>Yes</Radio.Button>
          <Radio.Button value={false}>No</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name="mapURL"
        label="Map URL"
        rules={[{ type: "url", message: "Must be a valid URL" }]}
      >
        <Input
          type="url"
          placeholder="If exists, include 'http://', 'https://''"
        />
      </Form.Item>
      <Form.Item
        name="productURL"
        label="Product URL"
        rules={[{ type: "url", message: "Must be a valid URL" }]}
      >
        <Input
          type="url"
          placeholder="If exists, include 'http://', 'https://''"
        />
      </Form.Item>
      <Form.Item
        name="dataURL"
        label="Data URL"
        rules={[{ type: "url", message: "Must be a valid URL" }]}
      >
        <Input
          type="url"
          placeholder="If exists, include 'http://', 'https://''"
        />
      </Form.Item>
      <Form.Item name="references" label="References">
        <TextArea />
      </Form.Item>
      <Form.Item name="cruiseReport" label="Cruise Report">
        <TextArea />
      </Form.Item>
    </Form>
  );
}

function formToEntry(form: FormInstance) {
  // Format dates
  const timespanMoments = form.getFieldValue("timespan");

  // Return entry
  return {
    parameter: form.getFieldValue("parameter"),
    expedition: form.getFieldValue("expedition"),
    instrument: form.getFieldValue("instrument"),
    unit: form.getFieldValue("unit"),
    waterDepth: form.getFieldValue("waterDepth"),
    spatialFrom: form.getFieldValue("spatialFrom"),
    spatialTo: form.getFieldValue("spatialTo"),
    temporalFrom:
      timespanMoments[0] === undefined
        ? null
        : timespanMoments[0].format("YYYY-MM-DD"),
    temporalTo:
      timespanMoments[1] === undefined
        ? null
        : timespanMoments[1].format("YYYY-MM-DD"),
    temporalResolution: form.getFieldValue("temporalResolution"),
    dataFormat: form.getFieldValue("dataFormat"),
    openAccess: form.getFieldValue("openAccess"),
    mapURL: form.getFieldValue("mapURL"),
    productURL: form.getFieldValue("productURL"),
    dataURL: form.getFieldValue("dataURL"),
    references: form.getFieldValue("references"),
    cruiseReport: form.getFieldValue("cruiseReport"),
  };
}

function entryToForm(form: FormInstance, entry: Entry) {
  form.setFieldsValue({
    ...entry,
    timespan: [moment(entry.temporalFrom), moment(entry.temporalTo)],
  });
}

export const CreateMarineModal = makeEntryModal(
  "Create Marine Observation",
  new TableAPI("marine"),
  renderForm,
  formToEntry,
  entryToForm
);
